import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import { AccountStorage } from "@services/account";
import { Cascader } from "@/components-v2/cascader";
import CheckBox from "@/components-v2/checkbox/index";
import Dialog from '@/components-v2/v2-dialog/index';
var accountStorage = new AccountStorage();
var phoneReg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
export default {
  data: function data() {
    return {
      addressShow: false,
      title: '新增收货地址',
      info: {
        address: null,
        site: "",
        consignee: "",
        information: ""
      },
      data: [],
      detailId: null,
      checkboxCustom: false,
      companyId: "",
      // 企业id
      isConsignee: false,
      isPhone: false,
      options: [],
      isSite: false,
      cityList: [],
      isTitle: false,
      defaultValue: "",
      check: null
    };
  },
  created: function created() {
    var loginCompanyId = accountStorage.getCacheUserInfo();
    this.companyId = loginCompanyId.loginCompanyId;
    this.getAddressList();
    this.areaCodeList();
  },
  components: {
    Cascader: Cascader,
    CheckBox: CheckBox,
    Dialog: Dialog
  },
  filters: {
    ellipsis: function ellipsis(value) {
      if (!value) return "";
      if (value.length > 13) {
        return value.slice(0, 13) + "...";
      }
      return value;
    }
  },
  methods: {
    areaCodeList: function areaCodeList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var api, res, _res$data, code, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              api = '/pjyy-deepexi-erp-api-center/api/v1/erp/areaCode/list';
              _context.next = 3;
              return _this.$getHttpClient().get(api);
            case 3:
              res = _context.sent;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              _this.options = data;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openDlg: function openDlg() {
      this.showDlg = true;
    },
    getAddressdata: function getAddressdata(data) {
      this.cityList = data;
      this.defaultValue = this.cityList[0].provinceName + "/" + this.cityList[1].cityName + "/" + this.cityList[2].districtName;
    },
    blurSite: function blurSite() {
      if (this.info.site === "") {
        this.isSite = true;
      } else {
        this.isSite = false;
      }
    },
    // 收货人
    blurConsignee: function blurConsignee() {
      if (this.info.consignee === "") {
        this.isConsignee = true;
      } else {
        this.isConsignee = false;
      }
    },
    blurPhone: function blurPhone() {
      if (!phoneReg.test(this.info.information)) {
        this.isPhone = true;
      } else {
        this.isPhone = false;
      }
    },
    onSearch: function onSearch() {},
    // 设为默认
    handleDefault: function handleDefault(id) {
      var _this2 = this;
      var that = this;
      this.$confirm('确定设为默认吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        var url = "/pjyy-deepexi-user-center/api/v1/address/setDefault?id=".concat(id);
        _this2.$getHttpClient().get(url).then(function (res) {
          if (res.data.code === "200") {
            that.getAddressList();
            _this2.$messageTip("设置成功！", 'success');
          }
        });

        // 成功
      }).catch(function (err) {
        // 失败
      });
    },
    // 列表
    getAddressList: function getAddressList() {
      var _this3 = this;
      var url = "/pjyy-deepexi-user-center/api/v1/address/addressList?companyId=".concat(this.companyId);
      this.$getHttpClient().get(url).then(function (res) {
        _this3.data = res.data.data;
      });
    },
    // 删除
    deleteById: function deleteById(id) {
      var _this4 = this;
      var url = "/pjyy-deepexi-user-center/api/v1/address/deleteById?id=".concat(id);
      this.$getHttpClient().get(url).then(function (res) {
        if (res.data.code === "200") {
          _this4.getAddressList();
        }
      });
    },
    // 确定
    handleSave: function handleSave() {
      var _this5 = this;
      if (this.defaultValue === "") {
        this.$refs.isValue.onBlur();
        return false;
      }
      if (this.info.site === "") {
        this.isSite = true;
        return false;
      } else if (this.info.consignee === "") {
        this.isConsignee = true;
        return false;
      } else if (!phoneReg.test(this.info.information)) {
        this.isPhone = true;
        return false;
      }
      var data = {
        addreDetail: this.info.site,
        provinceName: this.cityList[0].provinceName,
        province: this.cityList[0].province,
        cityName: this.cityList[1].cityName,
        city: this.cityList[1].city,
        districtName: this.cityList[2].districtName || "",
        district: this.cityList[2].district || "",
        companyId: this.companyId,
        consignee: this.info.consignee,
        consigneePhone: this.info.information,
        defaultStatus: this.checkboxCustom ? 1 : 0,
        id: this.detailId
      };
      var url = "/pjyy-deepexi-user-center/api/v1/address/save";
      this.$getHttpClient().post(url, data).then(function (res) {
        if (res.data.code === "200") {
          _this5.handleCancel();
          _this5.getAddressList();
        }
      });
    },
    // 编辑
    handleDetail: function handleDetail(row) {
      this.checkboxCustom = row.defaultStatus == 0 ? false : true;
      this.cityList = [{
        provinceName: row.provinceName,
        province: row.province
      }, {
        cityName: row.cityName,
        city: row.city
      }, {
        districtName: row.districtName || "",
        district: row.district || ""
      }];
      this.addressShow = true;
      if (this.addressShow) {
        this.isTitle = true;
      }
      this.defaultValue = row.provinceName + "/" + row.cityName + "/" + row.districtName;
      this.detailId = row.id;
      this.info.address = row.city;
      this.info.site = row.addreDetail;
      this.info.consignee = row.consignee;
      this.info.information = row.consigneePhone;
    },
    // 点击新增收货
    handleSite: function handleSite() {
      this.defaultValue = '';
      this.addressShow = true;
    },
    handleCancel: function handleCancel() {
      this.addressShow = false;
      this.isTitle = false;
      this.info = {
        address: null,
        site: "",
        consignee: "",
        information: ""
      };
    }
  },
  updated: function updated() {}
};